import { defineComponent as _defineComponent } from 'vue';
import { resolveComponent as _resolveComponent, createVNode as _createVNode, createElementVNode as _createElementVNode, normalizeClass as _normalizeClass, withCtx as _withCtx, unref as _unref, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createElementBlock as _createElementBlock } from "vue";
const _hoisted_1 = {
  class: "absolute top-0 left-0 right-0 bottom-0 flex"
};
const _hoisted_2 = {
  class: "w-full"
};
const _hoisted_3 = {
  class: "title-wrapper"
};
const _hoisted_4 = {
  class: "title-wrapper"
};
const _hoisted_5 = {
  class: "title-wrapper"
};
const _hoisted_6 = {
  class: "w-full h-full px-[20px]"
};
import Left from './components/Left.vue';
import { MindMapContentExample } from '@/views/aip/utils/constants';
import { nextTick, onMounted, ref } from 'vue';
import { useRouter } from "vue-router";
import { KnowledgeApi } from '@/api/ai/knowledge/knowledge';
import KnowledgeDocument from '@/views/aip/knowledge/document/index.vue';
import KnowledgeRetrieval from '@/views/aip/knowledge/knowledge/retrieval/index.vue';
import KnowledgeSetting from './components/KnowledgeForm.vue';
import DocumentSegment from '@/views/aip/knowledge/segment/index.vue';
export default /*@__PURE__*/_defineComponent({
  ...{
    name: 'AiMindMap'
  },
  __name: 'index',
  setup(__props) {
    const router = useRouter();
    const knowledgeId = router.currentRoute.value.query["knowledgeId"];
    const knowledge = ref();
    // console.log('knowledgeId:'+knowledgeId);
    const currentNavKey = ref('doc');
    const showSegment = ref(false);
    const isWriting = ref(false); // 是否正在写作中
    const isEnd = ref(true); // 用来判断结束的时候渲染思维导图
    const documentId = ref();
    const generatedContent = ref(''); // 生成思维导图结果
    const segmentRef = ref();
    const leftRef = ref(); // 左边组件
    const back = () => {
      // 路由返回
      router.back();
    };
    /** 使用已有内容直接生成 **/
    const directGenerate = existPrompt => {
      isEnd.value = false; // 先设置为 false 再设置为 true，让子组建的 watch 能够监听到
      generatedContent.value = existPrompt;
      isEnd.value = true;
      isWriting.value = true;
    };
    const handleNav = key => {
      currentNavKey.value = key;
      showSegment.value = false;
    };
    const handleSegment = doc => {
      documentId.value = doc.id;
      // handleNav('segment')
      showSegment.value = true;
      nextTick(() => {
        segmentRef.value?.initData(doc.id, doc.name);
      });
    };
    const handleSegmentClose = () => {
      showSegment.value = false;
      handleNav('doc');
    };
    /** 初始化 */
    onMounted(async () => {
      generatedContent.value = MindMapContentExample;
      if (knowledgeId && typeof knowledgeId === 'string') {
        knowledge.value = await KnowledgeApi.getKnowledge(knowledgeId);
      }
    });
    return (_ctx, _cache) => {
      const _component_el_divider = _resolveComponent("el-divider");
      const _component_Icon = _resolveComponent("Icon");
      return _openBlock(), _createElementBlock("div", _hoisted_1, [_createVNode(Left, {
        ref_key: "leftRef",
        ref: leftRef,
        knowledge: knowledge.value,
        onBack: back
      }, {
        default: _withCtx(() => [_createElementVNode("div", _hoisted_2, [_createVNode(_component_el_divider, {
          class: "!mt-[10px] !mb-[10px]"
        }), _createElementVNode("div", null, [_createElementVNode("div", {
          class: _normalizeClass(["conversation", currentNavKey.value === 'doc' ? 'active' : '']),
          onClick: _cache[0] || (_cache[0] = $event => handleNav('doc'))
        }, [_createElementVNode("div", _hoisted_3, [_createVNode(_component_Icon, {
          icon: "hugeicons:chat-bot",
          class: "mr-5px"
        }), _cache[3] || (_cache[3] = _createElementVNode("span", {
          class: "title"
        }, "文档", -1))])], 2), _createElementVNode("div", {
          class: _normalizeClass(["conversation", currentNavKey.value === 'test' ? 'active' : '']),
          onClick: _cache[1] || (_cache[1] = $event => handleNav('test'))
        }, [_createElementVNode("div", _hoisted_4, [_createVNode(_component_Icon, {
          icon: "hugeicons:chat-bot",
          class: "mr-5px"
        }), _cache[4] || (_cache[4] = _createElementVNode("span", {
          class: "title"
        }, "召回测试", -1))])], 2), _createElementVNode("div", {
          class: _normalizeClass(["conversation", currentNavKey.value === 'setting' ? 'active' : '']),
          onClick: _cache[2] || (_cache[2] = $event => handleNav('setting'))
        }, [_createElementVNode("div", _hoisted_5, [_createVNode(_component_Icon, {
          icon: "hugeicons:chat-bot",
          class: "mr-5px"
        }), _cache[5] || (_cache[5] = _createElementVNode("span", {
          class: "title"
        }, "设置", -1))])], 2)])])]),
        _: 1
      }, 8, ["knowledge"]), _createElementVNode("div", _hoisted_6, [currentNavKey.value === 'doc' && !showSegment.value ? (_openBlock(), _createBlock(KnowledgeDocument, {
        key: 0,
        knowledgeId: _unref(knowledgeId),
        onDocumentSegmentView: handleSegment
      }, null, 8, ["knowledgeId"])) : _createCommentVNode("", true), currentNavKey.value === 'test' ? (_openBlock(), _createBlock(KnowledgeRetrieval, {
        key: 1,
        knowledgeId: _unref(knowledgeId)
      }, null, 8, ["knowledgeId"])) : _createCommentVNode("", true), currentNavKey.value === 'setting' ? (_openBlock(), _createBlock(KnowledgeSetting, {
        key: 2,
        knowledgeId: _unref(knowledgeId)
      }, null, 8, ["knowledgeId"])) : _createCommentVNode("", true), showSegment.value ? (_openBlock(), _createBlock(DocumentSegment, {
        key: 3,
        ref_key: "segmentRef",
        ref: segmentRef,
        onBack: handleSegmentClose
      }, null, 512)) : _createCommentVNode("", true)])]);
    };
  }
});